export interface IAllFilters {
  key: string;
  label: string;
  filters: Filter[];
}
export interface Filter {
  key: string;
  label: string;
  param: string;
  checked: boolean;
  expected:boolean;
}

export function onApplyFilters(selectedList:any[],selectedFilters:Record<string,boolean>,allFilters:IAllFilters[]){
 
  let list = [...selectedList];
  if (list.length === 0) {
    return list;
  }
  allFilters.forEach((section: IAllFilters) => {
    const all = section.filters.every((filter: Filter) => selectedFilters[filter.key]);
    const neither = section.filters.every((filter: Filter) => !selectedFilters[filter.key]);
    
    if (!(all || neither)) {
      /** From 'list', only return those items which exist in 'filters' and match expectation */
      list = list.filter((item) => {
        return section.filters.filter(
          (filter: Filter) =>  selectedFilters[filter.key] &&  item[filter.param] === filter.expected
          
        ).length;
      });
    }
  });
  return list;
}